<template>
  <img v-if="src" alt="" :src="src" @click="$emit('click')" />
  <img v-else :src="defaultImg" @click="$emit('click')" />
</template>

<script>
import { VUE_APP_API_PATH } from "@/store/constant";

export default {
  name: "VImg",
  props: {
    attachmentId: {
      type: String,
      default: "",
    },
    defaultImg: {
      type: String,
      default() {
        return require("@/assets/img/mediaApp2.png");
      },
    },
  },
  computed: {
    src() {
      if (!this.attachmentId) {
        return null;
      }
      return `${VUE_APP_API_PATH}/file/${this.attachmentId}/download`;
    },
  },
};
</script>

<style scoped></style>
